import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Profile from './components/Profile';
import Publications from './components/Publications';
import CV from './components/CV';
import Login from './components/login';
import PrivateRoute from './components/PrivateRoute';
import PrivateComponent from './components/private/privatePage';
import Drive from './components/private/Drive';


function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Profile />} />
          <Route path="/publications" element={<Publications />} />
          <Route path="/CV" element={<CV />} />
          <Route path="/login" element={<Login />} />
          <Route element={<PrivateRoute />}>
            <Route path="/private/privatePage" element={<PrivateComponent />} />
            <Route path="/drive" element={<Drive />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
